/* eslint-disable react-hooks/exhaustive-deps */
import { Callout } from "@blueprintjs/core"
import { useState } from "react"
import { __ } from "src/libs/utilities"
import { CardFiled } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import CardField from "./CardField"

/* Protopia Ecosystem component */
export interface ICardTemplateFormProps {
   
}
const CardTemplateForm = (props: ICardTemplateFormProps): JSX.Element => { 
    const data = useLandingStore((state: ILandingStore) => state.currentCardEdit)
    const [value,]  = useState<any[]>( data?.cards[0].value || [] ) 
    if(!data) {
        return <div className="container  mx-2 width-auto">            
            <Callout className="p-4 my-3 letter-spacing-1 row width-auto">
                <div className="small col-12">
                    {__("No cards selected")}
                </div>
                <div className="micro mt-2 col-12">
                    {__("Select some meat with cards")}
                </div>
            </Callout>
        </div>
    }
    const card_fields: CardFiled[] = data?.card_fields || []
    const order: string[] = data?.order || []

    // console.log( data.card_fields, data.cards )
    const compareByOrder = (a : CardFiled, b : CardFiled) => {
        const sa = order.findIndex( n => n === a.type )
        const sb = order.findIndex( n => n === b.type )
        if(sa > sb) {
            return 1
        }
        else if( sa < sb ) {
            return -1
        }
        return 0; 
    }
    return <div className='pe-card-template-form-container'>
        {
            card_fields.map((cf, i) => ({ ...cf, num: i}))
            // .sort( compareByOrder )
            .filter( cf => order.includes( cf.type ) )
            .map(( cf, i ) => <div className="position-relative" key={ cf.type } > 
                <CardField 
                    data={ cf } 
                    cardData={ data?.cards[ 0 ] || {} } 
                    i={ i } 
                    value={ value[ cf.num ] } 
                /> 
            </div>)
        }  {/* */}
    </div>
}
export default CardTemplateForm